import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({providedIn: "root"})

export class PushNotificationsService {
    public permission!: Permission;
    constructor() {
        // this.permission = this.isSupported() ? 'default' : 'denied';
        this.requestPermission();
    }
    public isSupported(): boolean {
        return 'Notification' in window;
    }
    requestPermission(): void {
        if ('Notification' in window) {
            Notification.requestPermission((status) => {
                this.permission = status;
            });
        }
    }
    create(title: string, options?: PushNotification): any {
        const self = this;
        return new Observable((obs) => {
            if (!('Notification' in window)) {
                obs.complete();
            }
            if (self.permission === 'granted') {
                const _notify = new Notification(title, options);
                _notify.onshow = function (e) {
                    return obs.next({
                        notification: _notify,
                        event: e
                    });
                };
                _notify.onclick = function (e) {
                    return obs.next({
                        notification: _notify,
                        event: e
                    });
                };
                _notify.onerror = function (e) {
                    return obs.error({
                        notification: _notify,
                        event: e
                    });
                };
                _notify.onclose = function () {
                    return obs.complete();
                };
            }
            else{
                obs.error('denied');
            }
        });
    }
    generateNotification(source: Array<any>): void {
        const self = this;
        source.forEach((item) => {
            const options: any = {
                body: item.alertContent,
                icon: '../resource/images/bell-icon.png'
            };
            const notify = self.create(item.title, options).subscribe();
        })
    }
}
export declare type Permission = 'denied' | 'granted' | 'default';
export interface PushNotification {
    body?: string;
    icon?: string;
    tag?: string;
    data?: any;
    renotify?: boolean;
    silent?: boolean;
    sound?: string;
    noscreen?: boolean;
    sticky?: boolean;
    dir?: 'auto' | 'ltr' | 'rtl';
    lang?: string;
    vibrate?: number[];
    requireInteraction?: boolean;
}
